import { CLIENT_CUSTOMER_API, CLIENT_CUSTOMER_SENT_MAIL_TEMP_PASSWORD_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { ICreatedCustomerModel, ICustomerModel, ICustomerSentMailTempPasswordResponseModel, IUpdatedCustomerModel } from "./customer.models";
export const createCustomerInfoAPI = async (model: ICreatedCustomerModel) => {
  return await apiClient.postHttp<number>(
    `${CLIENT_CUSTOMER_API}`,
     model
  );
};

export const updatedCustomerInfoAPI = async (model: IUpdatedCustomerModel) => {
  return await apiClient.putHttp(
    `${CLIENT_CUSTOMER_API}`, 
    model
  );
};

export const getCurrentCustomerInfoAPI = async () => {
  return await apiClient.getHttp<ICustomerModel>(
    `${CLIENT_CUSTOMER_API}`,
    undefined
  );
};

export const sentMailTempPasswordAPI = async (email: string) => {
  return await apiClient.getHttp<ICustomerSentMailTempPasswordResponseModel>(
    `${CLIENT_CUSTOMER_SENT_MAIL_TEMP_PASSWORD_API}`,
    {params:{
      email: email
    }},
    false,
  );
};